import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PageTitleService } from 'app/core/page-title/page-title.service';
import * as XLSX from 'xlsx';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';
import { SpinnerService } from './spinner.service';


@Injectable({
  providedIn: 'root'
})

export class CommonUtilService {

  constructor(private translateService: TranslateService,
    private pageTitleService: PageTitleService,
    private spinnerService: SpinnerService) { }

  public static LIMIT_SIZE_MB = 20; //Mb

  public static FILE_BAD_EXTENSION = 'Tipo di file errato';

  public static ROLE_USER = "ROLE_USER";

  public static ROLE_ADMIN = "ROLE_ADMIN";

  findInvalidControls(form) {
    const invalid = [];
    const controls = form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    console.log("These fields are invalid :");
    console.log(JSON.stringify(invalid));
  }

  downloadFile(name, fileBinary, doSplit) {

    var dataPart, contentType;
    if (doSplit) {
      var binaryParts = fileBinary.split(',');
      contentType = binaryParts[0].split(":")[1].split(";")[0];
      dataPart = binaryParts[1];
    } else {
      dataPart = fileBinary;
    }

    const blob = this.b64toBlob(dataPart, contentType);
    const file = new File([blob], name, { type: contentType });
    const blobUrl = URL.createObjectURL(file);

    var link = document.createElement('a');
    link.download = name;
    link.href = blobUrl;
    link.click();
  }

  private b64toBlob(b64Data, contentType) {
    const sliceSize = 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  getBase64FromFile(fileVal) {

    let splited = fileVal.split(';base64,');
    /* console.log(splited); */
    return splited[1];

  }

  enabledExtension(file, extensions) {
    let output = false;
    try {
      console.log('enabledExtension() file: ' + file.name);
      if (file.name) {
        let splitfile = file.name.split('.');
        let ext = '.' + splitfile[splitfile.length - 1];
        if (extensions.indexOf(ext) > -1) {
          output = true;
        }
      }
    } catch (err) {
      console.log(err);
    }
    return output;
  }

  decodeReportStatus(status) {
    switch (status) {
      case "OPEN":
        { return "Aperta"; }
      case "CLOSE":
        { return "Concluso"; }
      case "EXPIRE":
        { return "Scaduto"; }
    }
  }

  decodePaymentStatus(status) {
    switch (status) {
      case "PAID":
        { return "Pagata"; }
      case "UN_PAID":
        { return "Non Pagata"; }
    }
  }

  decodeUserStatus(status) {
    switch (status) {
      case "DA_ATTIVARE":
        { return "Da Attivare"; }
      case "ATTIVATO":
        { return "APPROVA"; }
      case "RIFIUTATO":
        { return "RIFIUTA"; }
      case "DISABILITATO":
        { return "DISABLE"; }
      default:{
        return status;
      }
    }
  }

  decodeCandidateStatus(status) {
    switch (status) {
      case "COMPLETE":
        { return "Completato"; }
      case "NOT_COMPLETE":
        { return "Non completato"; }
    }
  }

  decodeAssistenzaStatus(stato) {
    let output = '';
    if (stato) {
      switch (stato) {
        case "OPEN":
          { return "Aperto"; }
        case "IN_MANAGE":
          { return "In gestione"; }
        case "CLOSE":
          { return "Chiuso"; }
      }
      return output;
    }
  }

  decodeDocumentStatus(stato) {
    let output = '';
    if (stato) {
      switch (stato) {
        case "OPEN":
          { return "Aperto"; }
        case "CLOSE":
          { return "Chiuso"; }
      }
      return output;
    }
  }

  logout() {
    localStorage.clear();

    if (location.origin.includes(':8888')) {
      window.location.href = '/logout';
    } else {
      window.location.href = '/cas/logout';
    }
  }

  translateLang(lang) {

    this.translateService.stream(lang).subscribe((translated: string) => {
      this.pageTitleService.setTitle(translated);
    });
  }

  getTranslateLang(lang) {
    var stringValue;
    this.translateService.stream(lang).subscribe((translated: string) => {
      stringValue = translated;
    });
    return stringValue;
  }

  getPaymentMonthList(): any[] {

    let monthList = [];

    var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var curDate = new Date();
    var currentMonth = months[curDate.getMonth()];
    const previousYear = curDate.getFullYear() - 1;
    const currentYear = curDate.getFullYear();

    for (let month of months) {
      monthList.push(month.concat('-').concat(previousYear.toString()));
    }
    let found: Boolean = false;
    for (let month of months) {
      if (!found) {
        if (month === currentMonth) {
          monthList.push(month.concat('-').concat(currentYear.toString()));
          found = true;
        } else {
          monthList.push(month.concat('-').concat(currentYear.toString()));
        }
      }
    }
    return monthList;
  }

  getRoundUpScoreVal(score) {
    if (score != null && score !== "") {
      return Math.ceil(score);
    }
    return
  }

  getWorstCalResult(val) {
    let output = '';
    if (val) {
      switch (val) {
        case "OTHER":
          { return "NO"; }
        case "TOP":
          { return "NO"; }
        case "WORST":
          { return "SI"; }
      }
      return output;
    }
  }

  ExportAsExcel(sheetName: string, rows: any[], fileName: string) {

    let ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rows);

    let wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    XLSX.writeFile(wb, fileName);

  }

  ExportAsPDF(landscapePage: Boolean, headerData: any, bodyContent: any, fileName: string) {

    const bodyData = bodyContent.map(item => {
      let arr = [];
      for (let h of headerData) {
        arr.push(item[h]);
      }
      return arr;
    });

    let doc;
    if (landscapePage) {
      doc = new jsPDF('landscape');
    } else {
      doc = new jsPDF('portrait');
    }

    autoTable(doc, {
      head: [headerData],
      body: bodyData
    })
    autoTable(doc, {
      theme: 'striped',
      styles: { fillColor: [255, 0, 0] },
      columnStyles: { 0: { halign: 'center', fillColor: [255, 255, 255] } },
      margin: { top: 10 },
      body: [
        [{ content: '', colSpan: 2, rowSpan: 2, styles: { halign: 'center' } }],
      ],
      showHead: 'firstPage'
    })
    this.spinnerService.stop();
    doc.save(fileName);
  }

}